document.addEventListener('DOMContentLoaded', function () {
      document.getElementById('picture').addEventListener('change', function () {
        const files = this.files;
        let allFilesValid = true;

        // Clear previous file size info
        document.getElementById('fileSizeInfo').textContent = '';

        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const fileSizeInBytes = file.size;
          const fileSizeInMegabytes = fileSizeInBytes / (1024 * 1024); // Convert to MB

          // Check if the file size exceeds the limit of 16 MB
          if (fileSizeInMegabytes > 5) {
            allFilesValid = false;
            document.getElementById('fileSizeInfo').innerHTML += `<p>File "${file.name}" exceeds the size limit of 5MB.</p>`;
          }
        }

        // If any file is too large, handle accordingly (e.g., disable a submit button)
        if (!allFilesValid) {
          //alert("One or more files exceed the size limit. Please select files that are each smaller than 5MB.");
          // Example: disable submit button
          document.getElementById('submitFormButton').disabled = true;
        } else {
          // All files are valid, enable submit button if previously disabled
          document.getElementById('submitFormButton').disabled = false;
        }
      });
    });

    document
      .getElementById("submitFormButton")
      .addEventListener("click", submitForm);

    const ENDPOINT_URL =
      "https://prod-104.westeurope.logic.azure.com:443/workflows/050293c314344212a022f9baabdfbe6e/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=l5Ptr0s7E6Rwaxdv1dWes9ru12S6TOHBi-413WSUAo0";

    const FIRST_NAME_ID = "firstName";
    const LAST_NAME_ID = "lastName";
    const EMAIL_ID = "email";
    const PHONE_ID = "phone";
    const ORDER_NUMBER_ID = "orderNumber";
    const INVOICE_NUMBER_ID = "invoiceNumber";
    const CASETYPE_ID = "caseType";
    const DESCRIPTION_ID = "description";
    const PICTURE_ID = "picture";

    function sanitizeInput(rawInput) {
      // Implement your sanitization logic here
      // For example, remove HTML tags, script tags, etc.
      return rawInput.replace(/<\/?[^>]+(>|$)/g, "");
    }

    async function getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
      });
    }

    function addHashPrefix(orderId) {
      return orderId && !orderId.startsWith("#") ? "#" + orderId : orderId;
    }

    function clearFormFields() {
      // Clear the form fields
      document.getElementById(FIRST_NAME_ID).value = "";
      document.getElementById(LAST_NAME_ID).value = "";
      document.getElementById(EMAIL_ID).value = "";
      document.getElementById(PHONE_ID).value = "";
      document.getElementById(ORDER_NUMBER_ID).value = "";
      document.getElementById(INVOICE_NUMBER_ID).value = "";
      document.getElementById(CASETYPE_ID).value = "";
      document.getElementById(DESCRIPTION_ID).value = "";
      document.getElementById(PICTURE_ID).value = "";
    }

    function hideMessage() {
      // Remove any existing alert
      const existingAlert = document.querySelector(".alert");
      if (existingAlert) existingAlert.remove();
    }

    function displaySuccess() {
      hideMessage();

      // Display a green text saying "Din henvendelse er sendt"
      const messageDiv = document.createElement("div");
      messageDiv.className = "alert alert-success"; // Using Bootstrap classes for styling
      messageDiv.innerHTML = "Din henvendelse er sendt";
      document.getElementById("orderForm").appendChild(messageDiv);
    }

    function displayError() {
      let errorMessage;
      if (arguments.length === 0) {
        errorMessage =
          "Det er sket en fejl, din henvendelse er ikke modtaget";
      } else {
        errorMessage = arguments[0];
      }

      hideMessage();

      // Create a new div element for the error message
      const messageDiv = document.createElement("div");
      messageDiv.className = "alert alert-danger"; // Using Bootstrap classes for styling
      messageDiv.innerHTML = errorMessage.toString();

      // Append the error message div to the form
      document.getElementById("orderForm").appendChild(messageDiv);
    }

    // Function to show spinner
    function showSpinner() {
      document.getElementById("submitFormButton").hidden = true;
      document.getElementById("spinner").classList.remove("spinnerHidden");
    }

    // Function to hide spinner
    function hideSpinner() {
      document.getElementById("submitFormButton").hidden = false;
      document.getElementById("spinner").classList.add("spinnerHidden");
    }

    async function getPictureBase64Array() {
      const pictureBase64Array = [];
      const files = document.getElementById(PICTURE_ID).files;
      for (let i = 0; i < files.length; i++) {

        const base64 = await getBase64(files[i]);
        pictureBase64Array.push(base64);
      }
      return pictureBase64Array;
    }

    async function getFormData() {
      return {
        firstName: sanitizeInput(
          document.getElementById(FIRST_NAME_ID).value
        ),
        lastName: sanitizeInput(document.getElementById(LAST_NAME_ID).value),
        email: sanitizeInput(document.getElementById(EMAIL_ID).value),
        phone: sanitizeInput(document.getElementById(PHONE_ID).value),
        orderNumber: addHashPrefix(
          sanitizeInput(document.getElementById(ORDER_NUMBER_ID).value)
        ),
        invoiceNumber: sanitizeInput(
          document.getElementById(INVOICE_NUMBER_ID).value
        ),
        caseType: sanitizeInput(
          document.getElementById(CASETYPE_ID).value
        ),
        description: sanitizeInput(
          document.getElementById(DESCRIPTION_ID).value
        ),
        pictures: await getPictureBase64Array(),
      };
    }

    // Asynchronous Validation function
    async function validateForm() {
      const formData = await getFormData();
      const emptyFields = [];

      console.log(formData);

      // Validate Email
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.email)) {
        return "Ugyldig Email Adresse";
      }

      // Validate Phone Number (very basic example)
      const phoneRegex =
        /^(?:(?:\+|00)\d{1,4} ?)?(\d{2} \d{2} \d{2} \d{2}|\d{8})$/;
      if (!phoneRegex.test(formData.phone)) {
        return "Ugyldigt Telefonnummer";
      }

      for (const [key, value] of Object.entries(formData)) {
        // Skip checking 'orderNumber' and 'pictures' as they are not mandatory
        if (
          key === "orderNumber" ||
          key === "pictures" ||
          key === "invoiceNumber"
        )
          continue;

        if (!value) {
          // Convert the key from camelCase to Title Case for a more user-friendly message
          const fieldName = key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase());
          emptyFields.push(fieldName);
        }
      }

      // Check if both 'orderNumber' and 'invoiceNumber' are empty or if 'orderNumber' is just a '#'
      if (
        (!formData.orderNumber || formData.orderNumber.trim() === "#") &&
        !formData.invoiceNumber
      ) {
        return "Enten ordrenummer eller fakturanummer skal udfyldes.";
      }

      if (formData.caseType == "") {
        return "Der skal vælges en sagstype";
      }

      if (formData.pictures.length > 3) {
        return "Der kan maksimalt uploades 3 billeder.";
      }

      if (formData.pictures.length < 1) {
        return "Der skal uploades minimum et billede og maks 3 billeder.";
      }

      if (emptyFields.length > 0) {
        const emptyFieldsString = emptyFields.join(", ");
        return `De følgende felter er påkrævet : ${emptyFieldsString}`;
      }

      return null; // No validation errors
    }

    async function submitForm() {
      try {
        hideMessage();
        showSpinner();

        const validationError = await validateForm();
        if (validationError) {
          displayError(validationError);
          return;
        }

        const payloadData = await getFormData();
        console.log(JSON.stringify(payloadData));

        const response = await fetch(ENDPOINT_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payloadData),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        console.log(result);
        clearFormFields();
        displaySuccess();
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
        displayError(error);
      } finally {
        hideSpinner();
      }
    }